import React, { useState, useContext } from 'react';
import { signInWithPhoneNumber } from "firebase/auth";
import { PersonContext } from '../providers/Person.jsx';
import { s } from '../Style.jsx';
import functions from '../utils/functions.js';

const Login = ({ componentOnly, title = "Sign in to get started!" }) => {

    const [phone, setPhone] = useState('');
    const [code, setCode] = useState('');
    const [confirm, setConfirm] = useState(null);
    const [error, setError] = useState('');
    const [loadingSignin, setLoadingSignin] = useState(false);
    const [loadingAuth, setLoadingAuth] = useState(false);

    const { setUser, auth, appVerifier } = useContext(PersonContext);

    const handleVerifyCode = () => {
        setError("");
        setLoadingAuth(true);
        confirm.confirm(code).then((result) => {
            console.log({result});
            setUser(result?.user);
            setConfirm(null);
            setCode('');
            setPhone('');
            setLoadingAuth(false);
            window.location.href = window.location.href.includes("cart") ? window.location.href : "/account";
        }).catch((err) => {
            console.log(err);
            setError("Invalid code.");
            setConfirm(null);
            setCode('');
            setLoadingAuth(false);
        });
    };

    const handleSignIn = async () => {
        setError("");
        setLoadingSignin(true);
        signInWithPhoneNumber(auth, phone, appVerifier)
            .then((confirmationResult) => {
                console.log({confirmationResult});
                setConfirm(confirmationResult);
                setLoadingSignin(false);
            }).catch((err) => {
                console.log(err);
                setError("SMS not sent.");
                setLoadingSignin(false);
            });
    };

    const loginComponent = <>

        <div className="signInContainer">
            {confirm ? (
                loadingAuth
                    ? <i className={"fas fa-spinner fa-spin"}></i>
                    : <div>
                        <div style={{ fontSize: 18, marginBottom: 20 }}>Verifying {functions.formatPhone(phone)}</div>
                        <input
                            style={{ padding: 10, marginRight: 10 }}
                            type="text"
                            value={code}
                            onInput={e => setCode(e.target.value.replace(/\D/g, ''))}
                            placeholder="Verification code"
                        />
                        <button style={{ padding: 10, border: "1px solid rgb(203, 33, 33)", backgroundColor: "rgb(203, 33, 33)", color: "white", borderRadius: 4 }}
                            onClick={handleVerifyCode}>Verify Code</button>
                    </div>
            ) : (
                loadingSignin
                    ? <i className={"fas fa-spinner fa-spin"}></i>
                    : <div>
                        <div style={{ fontSize: 18, marginBottom: 20 }}>{title}</div>
                        <input
                            style={{ padding: 10, marginRight: 10 }}
                            type="text"
                            value={phone}
                            onInput={e => setPhone('+1' + e.target.value.replace('+1', '').replace(/\D/g, ''))}
                            placeholder="Phone number"
                        />
                        <button style={{ padding: 10, border: "1px solid rgb(203, 33, 33)", backgroundColor: "rgb(203, 33, 33)", color: "white", borderRadius: 4 }}
                            id="sign-in-button" onClick={handleSignIn}>Verify</button>
                    </div>
            )}
            {error && <p>{error}</p>}
        </div>
    </>;

    if (componentOnly)
        return loginComponent;

    return <>
        <div style={s.headerBox}>
            <div style={s.headerInnerBox}>

                <h1 style={{ marginBottom: 0 }}>My Account</h1>

            </div>
        </div>
        <div style={s.paddingContainer}>
            <div style={s.mobileContainer}>
                {loginComponent}
            </div>
        </div>
    </>;

}
export default Login;